var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 172,
    viewBox: "0 0 139 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_402_553)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.249,
    y: 33,
    width: 89.751,
    height: 106.069,
    rx: 4.89551,
    fill: "url(#paint0_linear_402_553)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_402_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 126.904C63.1035 127.193 63.1797 127.429 63.332 127.612C63.4843 127.795 63.6861 127.947 63.9374 128.069C64.1963 128.183 64.4781 128.286 64.7827 128.377C65.0873 128.469 65.3919 128.572 65.6965 128.686C66.0011 128.792 66.2791 128.929 66.5304 129.097C66.7817 129.257 66.9835 129.47 67.1358 129.737C67.2957 129.996 67.3757 130.323 67.3757 130.719C67.3757 131.252 67.2386 131.69 66.9645 132.033C66.6979 132.375 66.34 132.63 65.8907 132.798C65.4414 132.958 64.9502 133.038 64.4172 133.038C64.0364 133.038 63.648 133 63.252 132.924C62.8561 132.84 62.4677 132.718 62.0869 132.558L62.1555 130.685H62.7152L62.9094 132.147L62.7951 131.953C63.0617 132.075 63.3396 132.166 63.629 132.227C63.9184 132.288 64.2001 132.318 64.4743 132.318C64.8322 132.318 65.1597 132.265 65.4567 132.158C65.7536 132.044 65.9935 131.88 66.1763 131.667C66.3591 131.446 66.4504 131.172 66.4504 130.845C66.4504 130.54 66.3705 130.296 66.2106 130.114C66.0583 129.923 65.8565 129.767 65.6052 129.645C65.3538 129.523 65.0759 129.417 64.7713 129.325C64.4667 129.234 64.1621 129.139 63.8575 129.04C63.5528 128.933 63.2749 128.8 63.0236 128.64C62.7723 128.48 62.5667 128.275 62.4068 128.023C62.2544 127.764 62.1783 127.437 62.1783 127.041C62.1783 126.554 62.2963 126.15 62.5324 125.83C62.7761 125.503 63.1035 125.259 63.5148 125.099C63.9336 124.939 64.3981 124.859 64.9084 124.859C65.2663 124.859 65.6394 124.897 66.0278 124.973C66.4162 125.05 66.7969 125.168 67.1701 125.327L67.0787 127.121H66.5076L66.3362 125.75L66.4733 125.887C66.2448 125.788 65.9973 125.712 65.7308 125.659C65.4643 125.605 65.1977 125.579 64.9312 125.579C64.619 125.579 64.322 125.624 64.0402 125.716C63.7585 125.8 63.53 125.94 63.3549 126.138C63.1873 126.329 63.1035 126.584 63.1035 126.904Z",
    fill: "url(#paint1_linear_402_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2269 132.353L70.1241 132.227L71.1179 132.444V132.935H68.4107V132.444L69.4045 132.227L69.3131 132.353V124.791L69.4045 124.893L68.4107 124.688V124.197L70.2269 124.117V132.353Z",
    fill: "url(#paint2_linear_402_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5466 133.038C74.0363 133.038 73.5832 132.924 73.1872 132.695C72.7989 132.459 72.4943 132.116 72.2734 131.667C72.0526 131.218 71.9422 130.67 71.9422 130.022C71.9422 129.36 72.0564 128.789 72.2848 128.309C72.5133 127.829 72.8369 127.46 73.2558 127.201C73.6746 126.934 74.1658 126.801 74.7293 126.801C75.2624 126.801 75.7003 126.915 76.043 127.144C76.3933 127.365 76.6522 127.673 76.8197 128.069C76.9949 128.465 77.0824 128.918 77.0824 129.428C77.0824 129.512 77.0786 129.596 77.071 129.68C77.0634 129.763 77.052 129.866 77.0367 129.988H72.639V129.337H76.2371L76.1343 129.405C76.142 129.063 76.1001 128.747 76.0087 128.457C75.9173 128.168 75.7612 127.936 75.5404 127.761C75.3195 127.585 75.0263 127.498 74.6608 127.498C74.2724 127.498 73.945 127.601 73.6784 127.806C73.4119 128.012 73.2139 128.294 73.0844 128.652C72.955 129.009 72.8903 129.424 72.8903 129.897C72.8903 130.399 72.9626 130.833 73.1073 131.199C73.252 131.557 73.4614 131.835 73.7355 132.033C74.0173 132.231 74.36 132.33 74.7636 132.33C75.0454 132.33 75.3538 132.276 75.6889 132.17C76.0239 132.056 76.3704 131.884 76.7283 131.656L77.0596 132.17C76.6331 132.459 76.2067 132.676 75.7802 132.821C75.3538 132.966 74.9426 133.038 74.5466 133.038Z",
    fill: "url(#paint3_linear_402_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7934 133.038C80.2832 133.038 79.8301 132.924 79.4341 132.695C79.0457 132.459 78.7411 132.116 78.5203 131.667C78.2994 131.218 78.189 130.67 78.189 130.022C78.189 129.36 78.3033 128.789 78.5317 128.309C78.7602 127.829 79.0838 127.46 79.5027 127.201C79.9215 126.934 80.4127 126.801 80.9762 126.801C81.5093 126.801 81.9471 126.915 82.2898 127.144C82.6401 127.365 82.899 127.673 83.0666 128.069C83.2417 128.465 83.3293 128.918 83.3293 129.428C83.3293 129.512 83.3255 129.596 83.3179 129.68C83.3103 129.763 83.2989 129.866 83.2836 129.988H78.8858V129.337H82.484L82.3812 129.405C82.3888 129.063 82.3469 128.747 82.2556 128.457C82.1642 128.168 82.0081 127.936 81.7872 127.761C81.5664 127.585 81.2732 127.498 80.9077 127.498C80.5193 127.498 80.1918 127.601 79.9253 127.806C79.6588 128.012 79.4608 128.294 79.3313 128.652C79.2019 129.009 79.1371 129.424 79.1371 129.897C79.1371 130.399 79.2095 130.833 79.3542 131.199C79.4988 131.557 79.7083 131.835 79.9824 132.033C80.2642 132.231 80.6069 132.33 81.0105 132.33C81.2922 132.33 81.6007 132.276 81.9357 132.17C82.2708 132.056 82.6173 131.884 82.9752 131.656L83.3065 132.17C82.88 132.459 82.4536 132.676 82.0271 132.821C81.6007 132.966 81.1894 133.038 80.7934 133.038Z",
    fill: "url(#paint4_linear_402_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.196 135.562V135.071L85.2355 134.831L85.087 135.003V127.498L85.2241 127.646L84.196 127.429V126.938L85.7952 126.858L85.9094 127.852L85.8066 127.783C86.1569 127.456 86.5072 127.212 86.8575 127.052C87.2078 126.885 87.5543 126.801 87.897 126.801C88.3235 126.801 88.7042 126.919 89.0393 127.155C89.382 127.391 89.6523 127.734 89.8503 128.183C90.0483 128.625 90.1473 129.169 90.1473 129.817C90.1473 130.517 90.0255 131.107 89.7818 131.587C89.5457 132.067 89.2107 132.432 88.7766 132.684C88.3425 132.927 87.8323 133.049 87.2459 133.049C87.0327 133.049 86.8119 133.03 86.5834 132.992C86.3549 132.954 86.1151 132.905 85.8638 132.844L86.0008 132.718V135.003L85.8752 134.843L87.0517 135.071V135.562H84.196ZM87.1431 132.364C87.8133 132.364 88.3235 132.147 88.6738 131.713C89.0241 131.279 89.1992 130.677 89.1992 129.908C89.1992 129.405 89.1269 128.975 88.9822 128.617C88.8451 128.259 88.6547 127.985 88.4111 127.795C88.1674 127.597 87.8894 127.498 87.5772 127.498C87.3107 127.498 87.0327 127.57 86.7433 127.715C86.4616 127.852 86.176 128.065 85.8866 128.355L86.0008 128.069V132.353L85.8752 132.147C86.3397 132.292 86.7624 132.364 87.1431 132.364Z",
    fill: "url(#paint5_linear_402_553)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_402_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.333 78.6914H55.2783V72.1682H65.8852C67.2356 72.1682 68.333 73.2656 68.333 74.6159V78.6914Z",
    fill: "url(#paint6_linear_402_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.602 82.6282H55.2783V77.0637H100.154C101.504 77.0637 102.602 78.1611 102.602 79.5114V82.6282Z",
    fill: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.602 83.081H65.4121L65.4611 77.8918C65.4733 76.7536 65.714 75.6276 66.1913 74.5914C67.3948 71.9805 70.0057 67.2726 73.196 67.2726H90.0814C98.93 67.2726 102.602 74.4894 102.602 76.7944C102.602 79.0994 102.602 83.081 102.602 83.081Z",
    fill: "url(#paint7_linear_402_553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9627 81.1881V64.0294C56.9627 63.1156 56.2202 62.3731 55.3064 62.3731C54.3885 62.369 53.646 63.1115 53.646 64.0294V86.8343H56.0937L57.7256 83.5788H98.5214L100.153 86.8343H102.601V81.184L56.9627 81.1881Z",
    fill: "#795548"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_402_553",
    x: 0.612305,
    y: 0.363281,
    width: 155.024,
    height: 171.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_402_553",
    x: 29.4502,
    y: 94.7436,
    width: 93.334,
    height: 76.7191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_402_553",
    x: 21.0093,
    y: 33,
    width: 114.229,
    height: 89.7346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.611765 0 0 0 0 0.8 0 0 0 0 0.396078 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_553",
    x1: 78.1245,
    y1: 33,
    x2: 78.1245,
    y2: 139.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#2C2C2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_553",
    x1: 53.7643,
    y1: 135.935,
    x2: 98.2591,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_553",
    x1: 53.7643,
    y1: 135.935,
    x2: 98.2591,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_553",
    x1: 53.7643,
    y1: 135.935,
    x2: 98.2591,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_553",
    x1: 53.7643,
    y1: 135.935,
    x2: 98.2591,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_553",
    x1: 53.7643,
    y1: 135.935,
    x2: 98.2591,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_553",
    x1: 61.8057,
    y1: 72.1682,
    x2: 61.8057,
    y2: 78.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5887FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3935FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_402_553",
    x1: 84.0075,
    y1: 67.2726,
    x2: 84.0075,
    y2: 83.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4701,
    stopColor: "#9CCC65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6909,
    stopColor: "#7CB342"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.e658eb46b06b8f44cad4601626622af6.svg";
export { ForwardRef as ReactComponent };